/**
 * @generated SignedSource<<65aa05400383c7a5ee3f3d8425207095>>
 * @relayHash 7d06535456c9d2141ca210b8d25ff802
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 982f9fe2ba3699920aaf981e5dd43474fb140f73d247765e842e033acbc8a0d9

import type { ConcreteRequest } from 'relay-runtime';
export type defaultSpacesForCreateQuery$variables = {
  cloudId: string;
  otherSpacesLimit?: number | null;
  promotedSpaceKeys?: ReadonlyArray<string | null> | null;
  promotedSpacesLimit?: number | null;
};
export type defaultSpacesForCreateQuery$data = {
  readonly confluence_defaultSpaces: {
    readonly matchedPromotedSpaces: {
      readonly spaces: ReadonlyArray<{
        readonly id: string;
        readonly key: string;
        readonly name: string | null;
      }>;
    };
    readonly otherSpaces: {
      readonly spaces: ReadonlyArray<{
        readonly id: string;
        readonly key: string;
        readonly name: string | null;
      }>;
    };
    readonly promotedSpaces: {
      readonly spaces: ReadonlyArray<{
        readonly id: string;
        readonly key: string;
        readonly name: string | null;
      }>;
    };
  } | null;
};
export type defaultSpacesForCreateQuery = {
  response: defaultSpacesForCreateQuery$data;
  variables: defaultSpacesForCreateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherSpacesLimit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "promotedSpaceKeys"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "promotedSpacesLimit"
},
v4 = [
  {
    "concreteType": "ConfluenceDefaultSpace",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      }
    ]
  }
],
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "otherSpacesLimit",
        "variableName": "otherSpacesLimit"
      },
      {
        "kind": "Variable",
        "name": "promotedSpaceKeys",
        "variableName": "promotedSpaceKeys"
      },
      {
        "kind": "Variable",
        "name": "promotedSpacesLimit",
        "variableName": "promotedSpacesLimit"
      }
    ],
    "concreteType": "ConfluenceDefaultSpaces",
    "kind": "LinkedField",
    "name": "confluence_defaultSpaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceDefaultSpaceResults",
        "kind": "LinkedField",
        "name": "matchedPromotedSpaces",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "concreteType": "ConfluenceDefaultSpaceResults",
        "kind": "LinkedField",
        "name": "promotedSpaces",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "concreteType": "ConfluenceDefaultSpaceResults",
        "kind": "LinkedField",
        "name": "otherSpaces",
        "plural": false,
        "selections": (v4/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "defaultSpacesForCreateQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "defaultSpacesForCreateQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "7d06535456c9d2141ca210b8d25ff802",
    "id": "982f9fe2ba3699920aaf981e5dd43474fb140f73d247765e842e033acbc8a0d9",
    "metadata": {},
    "name": "defaultSpacesForCreateQuery",
    "operationKind": "query",
    "text": "query defaultSpacesForCreateQuery($cloudId:ID!,$promotedSpaceKeys:[String],$promotedSpacesLimit:Int,$otherSpacesLimit:Int){confluence_defaultSpaces(cloudId:$cloudId,promotedSpaceKeys:$promotedSpaceKeys,promotedSpacesLimit:$promotedSpacesLimit,otherSpacesLimit:$otherSpacesLimit){matchedPromotedSpaces{spaces{id,key,name}},promotedSpaces{spaces{id,key,name}},otherSpaces{spaces{id,key,name}}}}"
  }
};
})();

(node as any).hash = "051a6dfeb5ad1a6654485dc46ce9bab5";

export default node;
